import { render } from "./offer-object.vue?vue&type=template&id=2944adb1"
import script from "./offer-object.vue?vue&type=script&lang=js"
export * from "./offer-object.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tasselchof/CodeProjects/oarus/oarus-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__